var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('span',{directives:[{name:"b-hover",rawName:"v-b-hover",value:(_vm.hoverHandler),expression:"hoverHandler"}],staticClass:"pb-2"},[_vm._v("\n  "+_vm._s(_vm.truncatedText)+"\n")])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-5489577a","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/views/private/crm/details/ajuizamento/TextTruncate.vue
// module id = null
// module chunks = 